// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"visually-hidden_visuallyHidden__sBMOc"};